import React from 'react';
import UnauthorizedRedirect from './components/UnauthorizedRedirect';
import { Loader, LoaderSizes } from '@hid-galaxy-ui/galaxy-react';
import { isAuthenticated } from './utils/authService';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import Header from './components/Header/Header';
import DefaultMainTemplate from './appTemplates/DefaultMainTemplate/DefaultMainTemplate';
import MainContentWrapper from './components/ContentWrapper/MainContentWrapper';
import Footer from './components/Footer/Footer';
import PageLoader from './components/PageLoader';
interface IRoute {
  component: React.ElementType;
  layout?: React.ElementType;
  [x: string]: any;
}

const RouteComponent = (props: IRoute) => {
  const {
    component: Component,
    layout: Layout,
    mainTemplate: MainTemplate = DefaultMainTemplate,
    isProtected,
  } = props;

  const isUserLoggedIn = isAuthenticated();

  const RenderProtectedComponent = () =>
    isUserLoggedIn ? RenderComponent() : <UnauthorizedRedirect />;

  const renderLoader = () => <PageLoader />;

  const RenderComponent = () =>
    Layout ? (
      <Layout>
        <React.Suspense
          fallback={
            <div className="hid-loader-full-page">{renderLoader()}</div>
          }
        >
          <MainTemplate>
            <Header />
            <MainContentWrapper>
              {/* <ErrorBoundary> */}
              <Component {...props} />
              {/* </ErrorBoundary> */}
            </MainContentWrapper>

            {<Footer />}
          </MainTemplate>
        </React.Suspense>
      </Layout>
    ) : (
      <React.Suspense
        fallback={<div className="hid-loader-full-page">{renderLoader()}</div>}
      >
        <MainTemplate>
          {/* <MainContentWrapper> */}
          {/* <ErrorBoundary> */}
          <Component {...props} />
          {/* </ErrorBoundary> */}
          {/* </MainContentWrapper> */}
        </MainTemplate>
      </React.Suspense>
    );

  return isProtected ? RenderProtectedComponent() : RenderComponent();
};

export default RouteComponent;
